import Vue from "vue"
import PortalClient, {hasServiceErrorCode, AccessTokenChangedEvent, AuthenticationTypeChangedEvent, ErrorCode, ExtensionHandler, IServiceError, ServiceError} from "@chaosinsight/portalclient"
import {PostOfficeErrorCode, RefreshTokenCreatedEvent} from "@chaosinsight/postoffice-portalclient"
import Configuration from "@/managers/system/configuration"
import Notifications from "@/managers/session/notifications"
import Token from "@/managers/authentication/token"

class Portal {
	public accessTokenExpiredHandler: ((token: string | null) => Promise<boolean>) | null = null

	private readonly _client!: PortalClient // tslint:disable-line
	private state = Vue.observable({accessToken: null as Token | null, authenticationType: null as string | null})

	public get client(): PortalClient {
		return this._client
	}

	public get call(): ExtensionHandler {
		return this._client.call
	}

	public get accessToken(): Token | null {
		return this.state.accessToken!
	}

	public get hasAccessToken(): boolean {
		return this.state.accessToken !== null
	}

	public get authenticationType(): string | null {
		return this.state.authenticationType
	}

	public constructor() {
		this._client = new PortalClient(Configuration.connections.portalPath, "8", (error, token) => this.handleError(error, token))
		this._client.addEventListener(AccessTokenChangedEvent.eventName, event => {
			const castEvent = event as AccessTokenChangedEvent
			this.state.authenticationType = castEvent.authenticationType
			this.state.accessToken = castEvent.accessToken !== null ? new Token(castEvent.accessToken) : null
		})
	}

	public clearSession(): void {
		Notifications.debug("Clearing Portal session")
		this.client.setAccessToken(null, null)
	}

	private handleError(error: IServiceError, token: string | null): Promise<boolean> {
		switch (error.Code) {
			case PostOfficeErrorCode.authorizationTokenExpired:
			case PostOfficeErrorCode.invalidAuthorizationToken:
				if (this.accessTokenExpiredHandler !== null) {
					Notifications.debug("Handling error " + error.Code + ": " + error.Message)
					return this.accessTokenExpiredHandler(token)
				}
				break
		}
		return Promise.resolve(false)
	}
}

export {ErrorCode, hasServiceErrorCode, PostOfficeErrorCode, ServiceError, AccessTokenChangedEvent, AuthenticationTypeChangedEvent, RefreshTokenCreatedEvent}
export default new Portal()
